import React, { useState } from 'react';

import { makeStyles } from '@mui/styles';
import { Box, Button, Toolbar } from '@mui/material';
import classNames from 'classnames';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import urlJoin from 'url-join';
import composerStyles from '../../composer.module.css';

const useStyles = makeStyles(() => ({
  root: {},
}));

const DemoPlayer = () => {
  const classes = useStyles();
  const { url } = useRouteMatch();
  const { pathname } = useLocation();
  const params = useParams();
  const history = useHistory();

  const handleCloseNavMenu = (video) => {
    history.push(urlJoin(url, video));
  };

  const pageGroups = {
    sports: [
      {
        name: 'Picture-in-Picture',
        page: 'pip',
        src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-sports-pip.mp4',
      },
      {
        name: 'Programmatic',
        page: 'programmatic',
        src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-sports-progamatic.mp4',
      },
      {
        name: 'Home Team Event',
        page: 'home-team-event',
        src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-sports-home-team-event.mp4',
      },
      {
        name: 'In-Play Event',
        page: 'in-play-event',
        src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-sports-in-play-event.mp4',
      },
    ],
    entertainment: [
      {
        name: 'Sponsored Overlay',
        page: 'sponsored-overlay',
        src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-entertainment-sponsored-overlay.mp4',
      },
      {
        name: 'Subscription Overlay',
        page: 'subscription-overlay',
        src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-entertainment-subscription-overlay.mp4',
      },
      {
        name: 'Stream Session Sponsorship',
        page: 'stream-session-sponsorship',
        src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-entertainment-stream-session-sponsorship.mp4',
      },
    ],
    news: [
      {
        name: 'Overlay',
        page: 'overlay',
        src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-news-overlay.mp4',
      },
      {
        name: 'Border Frame',
        page: 'boreder-frame',
        src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-news-border-frame.mp4',
      },
    ],
    extension: [
      {
        name: 'Game Day Highlighter',
        page: 'game-day-highlighter',
        src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-extension-game-day-highlighter.mp4',
      },
      {
        name: 'Next On',
        page: 'next-on',
        src: 'https://dxgcj7vu1u7nu.cloudfront.net/web-assets/demo-extension-next-on.mp4',
      },
    ],
  };

  // @ts-ignore
  const pages = pageGroups[params.category] || pageGroups[Object.keys(pageGroups)[0]] || [];

  const src = pages.find(({ page }) => {
    return page === pathname.split('/').pop();
  });
  const { src: videoSrc } = src || pages[0] || {};

  return (
    <div className={classNames(classes.root, composerStyles.mt)}>
      <Box>
        <Toolbar disableGutters className={classNames(composerStyles.justifyCenter)}>
          <Box className={composerStyles.demoVideos}>
            {pages.map(({ name, page, src: currentSrc }) => (
              <Button
                key={page}
                onClick={() => handleCloseNavMenu(page)}
                className={classNames(
                  composerStyles.demoCategoryUnderlineButtons,
                  composerStyles.secondaryButton,
                  composerStyles.underLinedButton,
                  {
                    [composerStyles.underLinedButtonActive]: videoSrc === currentSrc,
                  }
                )}
              >
                {name}
              </Button>
            ))}
          </Box>
        </Toolbar>

        <Box sx={{ width: 'min(1080px, calc(100vW - 50px))' }} className={composerStyles.mt2}>
          {videoSrc ? <video src={videoSrc} width="100%" height="100%" loop playsInline controls autoPlay /> : <Box />}
        </Box>
      </Box>
    </div>
  );
};

export default DemoPlayer;
